/** Created by azhou on 2019/3/8.*/
<template>
    <div class="container">
      <!-- <public-title :showBack="isAdmin || isGroup" v-if="queryCon.none!=1">门店资料</public-title> -->
      <public-title>企业资料· {{StoreBasicInfo.title}}</public-title>
      <div class="load-area">
        <el-tabs v-model="activeName" class="mb-3" @tab-click="handleClick">
          <el-tab-pane :label="item" :name="item" v-for="item in tabArr" :key="item" />
        </el-tabs>
        <!--采购商的酒店信息-->
        <t-reg-basic @saveInfo="saveBasicInfo" v-if="activeName==='酒店信息' && storeInfo.type===2"/>
        <!--酒店、民宿、景区的基础信息-->
        <h-reg-basic v-if="activeName==='酒店信息' && storeInfo.type!==2" @saveInfo="saveBasicInfo"/>
        <!--门店信息-->
        <div v-if="activeName==='门店信息'">
          <admin-set v-if="userInfo.type===99" ref="adminSet"/>
          <s-store-basic v-if="$GFUN.isInArray([6,8],storeInfo.type)" @saveInfo="saveBasicInfo"/>
          <h-store-basic v-if="$GFUN.isInArray([3,5],storeInfo.type)" @saveInfo="saveBasicInfo" :HStore="1"/>
          <t-store-basic v-if="storeInfo.type===2" @saveInfo="saveBasicInfo"/>
        </div>
        <!--设施标签-->
         <div v-if="activeName==='设施标签'">
          <h-store-basic v-if="$GFUN.isInArray([3,5],storeInfo.type)" @saveInfo="saveBasicInfo" :HStore="2"/>
         </div>
        <!--团队政策-->
        <div v-if="activeName==='团队政策'">
          <h-store-basic v-if="$GFUN.isInArray([3,5],storeInfo.type)" @saveInfo="saveBasicInfo" :HStore="3"/>
         </div>
        <store-album v-if="activeName==='门店相册' && storeInfo.type!==2" @saveInfo="editAlbum" area=""/>
        <verify-info  v-if="activeName==='认证信息'"/>
        <!--管理员房型会议室管理-->
        <RoomMeetLists :type="activeName=='房型管理'?3:4" v-if="activeName==='房型管理'||activeName==='会议室管理'"></RoomMeetLists>
      </div>  
    </div>
</template>

<script>
  import { mapGetters,mapState, mapActions,mapMutations } from 'vuex'
  import { UploadImages } from '@/assets/utils/uploadFiles'
  import TRegBasic from './Comps/TRegBasic'
  import TStoreBasic from './Comps/TStoreBasic'
  import HRegBasic from './Comps/HRegBasic'
  import StoreAlbum from './StoreAlbum.vue'
  import HStoreBasic from './Comps/HStoreBasic'
  import AdminSet from './Comps/AdminSet'
  import SStoreBasic from './Comps/SStoreBasic'
  import RoomMeetLists from '@/views/StoreInfo/RoomMeetsInfo/Comps/RoomMeetLists.vue'
  export default {
    name: 'Index',
    components: { SStoreBasic, AdminSet, StoreAlbum, HRegBasic, TStoreBasic, TRegBasic,HStoreBasic,RoomMeetLists},
    computed: {
      ...mapState(['StoreBasicInfo',]),
      ...mapGetters(['storeInfo','userInfo','isGroup','isAdmin']),
      queryCon() { return this.$route.query },
      tabArr() {
        let arr=[]
        if(this.storeInfo.type!==2){
          arr = ['门店信息','设施标签','团队政策'];
          arr.push('房型管理','会议室管理');
          if (this.isAdmin) arr.splice(3,0,'门店相册');
        }else{
          arr = ['门店信息'];
        }
      
       return arr;
      }
    },
    data() {
      return {
        activeName:'酒店信息',
        none:0,
      }
    },
    mounted() {
      if (this.$route.query.store) {
        this.UPDATECURRENTSTORE({
          storeId:this.$route.query.store,
          type:Number(this.$route.query.type)
        });
      }
      // 页面创建时从路由读取
      let activeTab = this.$route.query.tab;
      this.activeName=activeTab || '门店信息';
      this.getInfo();
    },
    destroyed() {
      this.UPDATECURRENTSTORE({storeId:'',type:''})
    },
    methods:{
      ...mapMutations(['UPDATECURRENTSTORE']),
      ...mapActions(['getUserHead','getStoreInfo','saveStoreInfo','HotelsEditAlbum']),
      /*获取门店信息*/
      getInfo() {
        let data = {};
        //管理员需要获取设置签约身份、门店负责人的数组
        if (this.isAdmin) {
          data.is_get_contract_arr = '1';
          data.is_get_admin_user_arr = '1';
        }
        this.getStoreInfo(data);
      },
      /*保存用户基础信息*/
      async saveBasicInfo(info) {
        console.log(info);
        let isRegStep = this.userInfo.type !== 99 && this.StoreBasicInfo.verify !== 1;
        if (this.isAdmin && this.activeName === '门店信息') {       //管理员身份设置的用户信息
          info = {
            ...info,
            contract:this.$refs.adminSet.BasicInfo.contract,
            rank:this.$refs.adminSet.BasicInfo.rank,
            person_liable_id:this.$refs.adminSet.BasicInfo.person_liable_id,
            display:this.$refs.adminSet.BasicInfo.display,
          }
        }
        if (this.isAdmin) {
          delete info.contractList;
          delete info.adminList;
          delete info.room_arr;
          delete info.meeting_arr;
          delete info.edit_verify;
        }
        if(this.$refs.adminSet && this.$refs.adminSet.contract_pic){
          info.contract_pic = await UploadImages(this.$refs.adminSet.contract_pic)
        }
        if(info.contract_pic)info.contract_pic=info.contract_pic.join(',');
        //return
        this.saveStoreInfo({
          newInfo: info,
          preservation:1,
          successFun: () => {
            //设施标签保存需更新头部信息
            if(this.activeName === '设施标签'){
              // this.getUserHead();
            }
            if (isRegStep) {            //单个门店注册页面
              this.getInfo(); 
              switch (this.storeInfo.type) {
                case 2:break;//this.$router.push({ name: 'regVerify' }); 
                case 3:break;
                case 5:
                case 6:
                  this.$router.push({ name: 'regStorePhotos',query:{step:2} }); break;
                default:break;
              }
            } else this.getInfo(); //管理员、单个门店、集团账号修改门店信息
          }
          })
      },
      /*保存用户基础信息*/
      async editAlbum(info) {
        if(this.$refs.adminSet && this.$refs.adminSet.contract_pic){
          info.contract_pic = await UploadImages(this.$refs.adminSet.contract_pic)
        }
        //return
        this.HotelsEditAlbum({
          newInfo: info,
          successFun: () => {          //单个门店注册页面
              this.getInfo();
        }})
      },
      /*tab切换*/
      handleClick(tab) {
        this.$router.replace({
          query: { ...this.$route.query,tab: tab.name }
        });
      }
    }
  }
</script>
